﻿import {
  opaccAjaxPlugin,
  opaccLocalStoragePlugin,
} from "./vendor/script/opacc.static.js";

/** @module filter */

/**
 * FunktionalitÃ¤t zur Aktualisierung des Filterkriteriums.
 */
export class OpaccFilterCriterias {
  constructor() {
    this.filterSelectorClass = ".opc-filter-set .filter-set-list";
    this.filterSelector =
      document.querySelector(this.filterSelectorClass) || undefined;
    this.filterInUrl =
      this.filterSelector !== undefined
        ? this.filterSelector.dataset.opFilterselectioninurl == "true"
        : false;
    this.hasRdFilter =
      document.querySelectorAll(".opc-filter[data-op-groupid]").length > 0;
    this.ajaxPagelayout = "asyn";
    this.catGroupId = "cat";

    if (typeof opaccFilterCriteriasData === "undefined") {
      window.opaccFilterCriteriasData = {};
    }
    this.initialRangeFilter();
    this.cleanTagValues();
    this.initSimpleDatePicker();
    this.initNormenFilter();
  }

  /**
   *
   *
   * @param {*} attrName
   * @param {*} attrValue
   * @param {boolean} [ajaxReq=true]
   * @param {*} [groupId=null]
   * @param {*} [filterId=null]
   */
  add(attrName, attrValue, ajaxReq = true, groupId = null, filterId = null) {
    if (!groupId) {
      groupId = this.catGroupId;
    }

    let data = {
      attrName: attrName,
      attrValue: attrValue,
      FilterId: filterId,
    };
    data = this.hookBeforeAdd(data);

    if (window.opaccFilterCriteriasData[groupId] === undefined) {
      window.opaccFilterCriteriasData[groupId] = [];
    }
    window.opaccFilterCriteriasData[groupId].push({
      AttrName: data.attrName,
      Value: data.attrValue,
      FilterId: filterId,
    });

    this.hookAfterAdd();
    if (ajaxReq) {
      this.sendAjaxRequest();
    }
  }

  /**
   *
   *
   * @param {*} [attrName=null]
   * @param {*} [attrValue=null]
   * @param {boolean} [ajaxReq=true]
   * @param {*} [groupId=null]
   * @param {*} [filterId=null]
   * @param {*} [initFilter=null]
   * @param {boolean} [resetAll=false]
   */
  remove(
    attrName = null,
    attrValue = null,
    ajaxReq = true,
    groupId = null,
    filterId = null,
    initFilter = null,
    resetAll = false
  ) {
    if (!groupId) {
      groupId = this.catGroupId;
    }

    let data = {
      attrName: attrName,
      attrValue: attrValue,
      FilterId: filterId,
    };
    data = this.hookBeforeRemove(data);

    if (!data.attrName) {
      if (resetAll) {
        Array.from(Object.keys(window.opaccFilterCriteriasData)).forEach(
          (key) => {
            window.opaccFilterCriteriasData[key] = [];
          }
        );
      } else {
        window.opaccFilterCriteriasData[groupId] = [];
      }
    } else {
      if (window.opaccFilterCriteriasData[groupId]) {
        // do reverse-loop for removing array-element
        let i = window.opaccFilterCriteriasData[groupId].length;
        while (i--) {
          if (
            (data.attrValue === null &&
              data.attrName ===
                window.opaccFilterCriteriasData[groupId][i].AttrName) ||
            (data.attrValue ===
              window.opaccFilterCriteriasData[groupId][i].Value &&
              data.attrName ===
                window.opaccFilterCriteriasData[groupId][i].AttrName)
          ) {
            window.opaccFilterCriteriasData[groupId].splice(i, 1);
          } else if (
            (data.attrValue === null &&
              data.FilterId ===
                window.opaccFilterCriteriasData[groupId][i].FilterId) ||
            (data.attrValue ===
              window.opaccFilterCriteriasData[groupId][i].Value &&
              data.FilterId ===
                window.opaccFilterCriteriasData[groupId][i].FilterId)
          ) {
            window.opaccFilterCriteriasData[groupId].splice(i, 1);
          }
        }
      }
    }

    if (initFilter) {
      let obj = JSON.parse(initFilter);
      Array.from(Object.keys(obj)).forEach((group) => {
        Array.from(Object.keys(obj[group])).forEach((filter) => {
          Array.from(obj[group][filter]).forEach((value) => {
            let filterId = `${group}-${filter}`;
            this.add("", value, false, group, filterId);
          });
        });
      });
    }

    this.hookAfterRemove();
    if (ajaxReq) {
      this.sendAjaxRequest();
    }
  }

  /**
   *
   *
   * @param {*} attrName
   * @param {*} attrValue
   * @param {boolean} [ajaxReq=true]
   * @param {*} [groupId=null]
   * @param {*} [filterId=null]
   */
  change(attrName, attrValue, ajaxReq = true, groupId = null, filterId = null) {
    if (!groupId) {
      groupId = this.catGroupId;
    }

    let data = {
      attrName: attrName,
      attrValue: attrValue,
      FilterId: filterId,
    };
    data = this.hookBeforeChange(data);
    let changed = false;

    if (window.opaccFilterCriteriasData[groupId]) {
      Array.from(window.opaccFilterCriteriasData[groupId]).forEach((i) => {
        if (data.attrName === i.AttrName) {
          i.Value = data.attrValue;
          changed = true;
        }
      });
    }

    // Criteria not exist
    if (!changed) {
      this.add(data.attrName, data.attrValue, false, groupId, filterId);
    }

    this.hookAfterChange();

    if (ajaxReq) {
      this.sendAjaxRequest();
    }
  }

  /**
   *
   *
   * @param {HTMLElement} filterwrapper Wrapper des aktuellen Filterfeldes
   * @returns {Array} Alle Inputfilter-Elemente innerhalb eines Filtersets
   */
  prepareFilterCriterias(filterwrapper) {
    let wrapper = filterwrapper.closest(this.filterSelectorClass);
    let elements = [
      ...wrapper.querySelectorAll(".op-form-input:not([readonly])"),
      ...wrapper.querySelectorAll(".opc-input:not([readonly])"),
    ].filter((elem) => {
      let elemWrapper = elem.closest(".opc-filter");
      if (elemWrapper && elemWrapper.querySelector(".select-list") === null) {
        return elem;
      }
    });
    return elements;
  }

  /**
   *
   *
   */
  sendAjaxRequest() {
    let data = {};
    let url = window.location.pathname;
    let qryString = window.location.search.substring(1);
    let qryStringFilter = "";

    if (qryString.length > 0) {
      let qryStringObj = JSON.parse(
        '{"' +
          decodeURI(qryString)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\\/g, "\\\\") +
          '"}'
      );
      for (let key in qryStringObj) {
        if (
          key.substring(0, 3) === "cf-" ||
          key.substring(0, 4) === "ppos" ||
          key.substring(0, 6) === "paging" ||
          window.opaccFilterCriteriasData[key] != undefined
        ) {
          delete qryStringObj[key];
        }
      }
      qryString = opaccAjaxPlugin.objectToQuerystring(qryStringObj, false);
    }

    if (this.hasRdFilter) {
      let selectionKeys = Object.keys(window.opaccFilterCriteriasData);
      let selectionValues = Object.values(window.opaccFilterCriteriasData);

      selectionValues.forEach((arr, idx) => {
        let key = selectionKeys[idx];
        let obj = {};

        arr.forEach((criteria) => {
          let id =
            key != this.catGroupId
              ? criteria.FilterId.substring(`${key}-`.length)
              : criteria.FilterId;

          if (obj[id]) {
            obj[id].push(criteria.Value);
          } else {
            obj[id] = [criteria.Value];
          }
        });

        let value = JSON.stringify(obj);
        data[key] = value;

        if (value != "{}") {
          let valueEncoded = encodeURIComponent(value);
          let valueBase64 = window.btoa(valueEncoded);
          let valueBase64UrlEncoded = encodeURIComponent(valueBase64);

          qryStringFilter += `${key}=${valueBase64UrlEncoded}&`;
        }
      });

      if (qryStringFilter) {
        qryStringFilter = qryStringFilter.substring(
          0,
          qryStringFilter.length - 1
        );
        qryStringFilter =
          qryString.length > 0
            ? `?${qryString}&${qryStringFilter}`
            : `?${qryStringFilter}`;
      } else if (qryString.length > 0) {
        qryStringFilter = `?${qryString}`;
      }

      url = `${window.location.pathname}${qryStringFilter}`;
    } else if (this.filterInUrl) {
      let selection = window.opaccFilterCriteriasData[this.catGroupId];
      if (selection) {
        data = selection.reduce((obj, item) => {
          obj[item.AttrName] = obj[item.AttrName] || [];
          obj[item.AttrName].push(item.Value.replace(/\[|\]/gi, ""));
          return obj;
        }, Object.create(null));
      }

      let i = 0;
      for (let key in data) {
        let delimiter = i > 0 ? "&" : "";
        qryStringFilter += `${delimiter}${key}=${encodeURIComponent(
          data[key].join("|")
        )}`;
        i++;
      }

      if (qryStringFilter) {
        qryStringFilter =
          qryString.length > 0
            ? `?${qryString}&${qryStringFilter}`
            : `?${qryStringFilter}`;
      } else if (qryString.length > 0) {
        qryStringFilter = `?${qryString}`;
      }

      url = `${window.location.pathname}${qryStringFilter}`;
    } else {
      let selection = window.opaccFilterCriteriasData[this.catGroupId];
      if (selection) {
        data = {
          selection: JSON.stringify(selection),
        };
      }

      url +=
        qryString.length > 0
          ? `?${qryString}&pagelayout=${this.ajaxPagelayout}`
          : `?pagelayout=${this.ajaxPagelayout}`;
    }

    data = this.hookBeforeReturnPrepareDataSubmission(data);
    this.hookBeforeSendAjaxRequest();

    opaccLocalStoragePlugin.removePersistentView(
      opaccLocalStoragePlugin.getCurrentURI()
    );
    opaccAjaxPlugin.fetchAsynPostForm(
      url,
      data,
      this.refreshResultList.bind(this),
      this.asyncErrorHandler.bind(this),
      true
    );

    if (this.hasRdFilter || this.filterInUrl) {
      history.replaceState(null, null, url);
    }
  }

  /**
   *
   *
   * @param {*} response
   */
  refreshResultList(response) {
    response = this.hookBeforeRefreshResultList(response);

    let targetSelector = ".content";
    let htmlObj = document.createElement("div");
    htmlObj.innerHTML = response.dataAsHtml;
    document.querySelector(targetSelector).innerHTML =
      htmlObj.querySelector(targetSelector).innerHTML;

    this.hookAfterRefreshResultList(response);

    this.firePseudoChangeEvent();

    this.initialRangeFilter();
    this.initSimpleDatePicker();
    this.cleanTagValues();
    this.firePseudoChangeEvent();
  }

  /**
   * Change-Event triggern, um asynchrone Change-Operationen auszufÃ¼hren
   * @private
   * @ignore
   */
  firePseudoChangeEvent() {
    let triggerEvent = new Event("change");
    document.querySelector(".content").dispatchEvent(triggerEvent);
  }

  // ---------------------------------

  /**
   *
   *
   * @param {*} error
   */
  asyncErrorHandler(error) {
    // eslint-disable-next-line no-console
    console.error("Request failed: ", error.message);
    this.hookAfterAsyncErrorHandler(error);
  }

  /**
   *
   *
   * @param {*} data
   * @returns {*}
   */
  hookBeforeAdd(data) {
    return data;
  }

  /**
   *
   *
   */
  hookAfterAdd() {}

  /**
   *
   *
   * @param {*} data
   * @returns {*}
   */
  hookBeforeRemove(data) {
    return data;
  }

  /**
   *
   *
   */
  hookAfterRemove() {}

  /**
   *
   *
   * @param {*} data
   * @returns {*}
   */
  hookBeforeChange(data) {
    return data;
  }

  /**
   *
   *
   */
  hookAfterChange() {}

  /**
   *
   *
   */
  hookBeforeSendAjaxRequest() {}

  /**
   *
   *
   * @param {*} data
   * @returns {*}
   */
  hookBeforeReturnPrepareDataSubmission(data) {
    return data;
  }

  /**
   *
   *
   * @param {*} data
   * @returns {*}
   */
  hookBeforeRefreshResultList(data) {
    return data;
  }

  /**
   *
   *
   * @param {*} data
   */
  // eslint-disable-next-line no-unused-vars
  hookAfterRefreshResultList(data) {}

  /**
   *
   *
   * @param {*} error
   */
  // eslint-disable-next-line no-unused-vars
  hookAfterAsyncErrorHandler(error) {}

  cleanTagValues() {
    const startElement = document.querySelector(
      '[data-op-filterattr="cf-startdatum"]'
    );

    if (startElement) {
      // Finde das erste übergeordnete div des Elements
      const startParentDiv = startElement.closest("div");

      if (startParentDiv) {
        // Finde das span-Element mit der Klasse 'tag-value' im übergeordneten div
        const startTagValueSpan =
          startParentDiv.querySelector("span.tag-value");
        const startTagValueTextSpan =
          startParentDiv.querySelector("span.tag-type");
        startTagValueTextSpan.innerText = window.projectText.filtervon;

        if (startTagValueSpan) {
          // Hole den inneren Text des span-Elements
          const startTagValueText = startTagValueSpan.innerText;

          // Splitte den Text beim Trennzeichen '-' und nimm nur das erste Segment
          const firstSegment = startTagValueText.split("-")[0];

          // Setze den inneren Text des span-Elements auf das erste Segment
          startTagValueSpan.innerText = firstSegment;
        }
      }
    }

    // Suche nach dem Element mit dem data-Attribut 'data-op-filterattr="cf-enddatum"'
    const endElement = document.querySelector(
      '[data-op-filterattr="cf-enddatum"]'
    );

    if (endElement) {
      // Finde das erste übergeordnete div des Elements
      const endParentDiv = endElement.closest("div");

      if (endParentDiv) {
        // Finde das span-Element mit der Klasse 'tag-value' im übergeordneten div
        const endTagValueSpan = endParentDiv.querySelector("span.tag-value");
        const endTagValueTextSpan = endParentDiv.querySelector("span.tag-type");
        endTagValueTextSpan.innerText = window.projectText.filterbis;

        if (endTagValueSpan) {
          // Hole den inneren Text des span-Elements
          const endTagValueText = endTagValueSpan.innerText;

          // Splitte den Text beim Trennzeichen '-' und nimm das zweite Segment
          const secondSegment = endTagValueText.split("-")[1];

          // Setze den inneren Text des span-Elements auf das zweite Segment
          if (secondSegment !== undefined) {
            endTagValueSpan.innerText = secondSegment;
          } else {
            // Falls kein zweites Segment existiert (z.B. der Text nur ein Segment hat)
            endTagValueSpan.innerText = "";
          }
        }
      }
    }
  }
  initialRangeFilter() {
    var value = "";

    var StartDate = moment().format("DD-MM-YYYY");
    var EndDate = moment().add(1, "M").format("DD-MM-YYYY");

    $(window.opaccFilterCriteriasData).each(function (i) {
      if (this.AttrName == "cf-startdatum") {
        if (this.Value != "") {
          value = this.Value.replace(/\[/g, "");
          value = value.replace(/\]/g, "");
          value = value.split("|");
          StartDate = value[0];

          document.querySelector(
            `.filter-tag-list [data-op-filterattr='${this.AttrName}']`
          ).previousElementSibling.innerText = StartDate;
        }
      }

      if (this.AttrName == "cf-enddatum") {
        if (this.Value != "") {
          value = this.Value.replace(/\[/g, "");
          value = value.replace(/\]/g, "");
          value = value.split("|");
          EndDate = value[1];
          document.querySelector(
            `.filter-tag-list [data-op-filterattr='${this.AttrName}']`
          ).previousElementSibling.innerText = EndDate;
        }
      }

      if (this.AttrName == "cf-release") {
        if (this.Value != "") {
          value = this.Value.replace(/\[/g, "");
          value = value.replace(/\]/g, "");
          value = value.split("|");
          EndDate = value[0];
          document.querySelector(
            `.filter-tag-list [data-op-filterattr='${this.AttrName}']`
          ).previousElementSibling.innerText = EndDate;
        }
      }
    });

    // $('span').filter('[data-op-filterattr=\'cf-release\']').prev('.tag-value').each(function(){
    //   if ($(this).text().includes('-')) {
    //     let tmpText = $(this).text();
    //     tmpText = tmpText.split('-')[0];
    //     $(this).text(tmpText);
    //     $('input').filter('[data-op-filterattr=\'cf-release\']').val(tmpText);
    //   }
    // });

    $(".opc-filter-set .tag-value").each(function () {
      if ($(this).text().includes(":")) {
        let tmpText = $(this).text();
        tmpText = tmpText.split(":")[1];
        tmpText = tmpText.replace(/\*/g, "");
        $(this).text(tmpText);
      }
    });

    $(".opc-filter-set .op-form-input").each(function () {
      if ($(this).val().includes(":")) {
        let tmpText = $(this).val();
        tmpText = tmpText.split(":")[1];
        tmpText = tmpText.replace(/\*/g, "");
        $(this).val(tmpText);
      }
    });

    $(".ele-input-daterange input").each(function () {
      $(this).daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        buttonClasses: "opc-btn",
        applyButtonClasses: "daterange-filter-apply",
        cancelButtonClasses: "daterange-filter-abort",
        locale: {
          format: "DD.MM.YYYY",
        },
      });

      $(this).on("apply.daterangepicker", function (ev, picker) {
        window.opaccFilterCriterias.remove("cf-startdatum", null, false);
        window.opaccFilterCriterias.remove("cf-enddatum", null, false);
        window.opaccFilterCriterias.add(
          "cf-startdatum",
          "[" + picker.startDate.format("DD.MM.YYYY") + "|01.09.2099]",
          false
        );
        window.opaccFilterCriterias.add(
          "cf-enddatum",
          "[01.01.2000|" + picker.endDate.format("DD.MM.YYYY") + "]",
          true
        );
      });
    });
  }

  initSimpleDatePicker() {
    $(".ele-single-datepicker").each(function () {
      let filterAttr = $(this).data("op-filterattr");

      $(this).daterangepicker({
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        buttonClasses: "opc-btn",
        applyButtonClasses: "daterange-filter-apply",
        cancelButtonClasses: "daterange-filter-abort",
        locale: {
          format: "DD.MM.YYYY",
        },
      });

      $(this).on("apply.daterangepicker", function (ev, picker) {
        window.opaccFilterCriterias.remove(filterAttr, null, false);
        window.opaccFilterCriterias.add(
          filterAttr,
          "[" + picker.startDate.format("DD.MM.YYYY") + "|01.09.2099]",
          true
        );
      });
    });
  }

  initNormenFilter() {
    $(".content").on("change", ".ele_flt", function () {
      if (this.type == "checkbox") {
        if (this.checked) {
          this.value = 1;
        } else {
          this.value = 0;
        }
      }

      let flt_active = $("#flt_valid").val();
      let flt_active_wb = $("#flt_active_wb").val();
      let flt_add = $("input[name=flt_add]:checked").val();
      let url = $(this).data("url");

      $.ajax({
        method: "POST",
        url: url,
        data: {
          flt_active: flt_active,
          flt_add: flt_add,
          flt_active_wb: flt_active_wb,
        },
      }).done(function () {
        window.location.href = window.location.href;
      });
    });
  }
}




